import { createSharedComposable } from '@vueuse/core';
import { computed } from 'vue';
import { useRoute } from 'vue-router/composables';
export const useDetailRoute = createSharedComposable(() => {
    const route = useRoute();
    /**
     * 数据源类型
     */
    const dataType = computed(() => {
        return route.params.dataType;
    });
    /**
     * 视图类型
     */
    const viewType = computed(() => {
        return route.params.viewType;
    });
    /**
     * 工作空间ID
     */
    const spaceId = computed(() => {
        return route.query.spaceId;
    });
    /**
     * 文件夹ID
     */
    const folderId = computed(() => {
        return route.query.folderId;
    });
    /**
     * 过滤条件
     */
    const cond = computed(() => {
        return route.query.cond;
    });
    const qid = computed(() => {
        return route.query.qid;
    });
    /**
     * EFQ ID
     */
    const efqId = computed(() => {
        return route.query.efqid;
    });
    /**
     * 排序
     */
    const sort = computed(() => {
        return route.query.sort || '';
    });
    /**
     * 页码
     */
    const page = computed(() => {
        return route.query.page || '1';
    });
    return {
        dataType,
        viewType,
        spaceId,
        folderId,
        cond,
        qid,
        efqId,
        sort,
        page,
    };
});
